import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../environments/environment';
import { TokenService } from './token.service';
import { ApiService } from './apiservice';
import { Advisory, OrderEntryRecords, OrderType } from '../app/interfaces/OrderEntryRecords';
import { ApiResponse, HistoryLogs, HistoryLogsRecords } from '../app/order-entry/order-entry-model/order-entry.model';

@Injectable({
  providedIn: 'root'
})
export class OrderEntryService {
  url: string;
  urlUserFilter: string;
  apiToken: string = "";
  userId: string = "";
  userObject: any;

  constructor(private http: HttpClient, private tokenService: TokenService, private apiService: ApiService) {
    this.url = environment.apiConfig.apiPath;
    this.urlUserFilter = environment.apiConfig.uri + environment.apiConfig.userIdFilter;
  }

  public getUser() {
    return this.apiService.getUser();
  }

  getCityData(groupId: any): Observable<OrderEntryRecords> {
    return this.apiService.get(this.url + `api/OrderEntry/GetAllStates/${groupId}`);
  }

  getOrderTypeData(groupId: any): Observable<OrderType> {
    return this.apiService.get(this.url + `api/OrderEntry/GetAllOrderType/${groupId}`);
  }

  getAdvisoriesData(): Observable<Advisory> {
    return this.apiService.get(this.url + 'api/CallCheckList/GetAdvisoriesRecords');
  }

  getOrderDataByCcrId(ccrId: string): Observable<ApiResponse> {
    return this.apiService.get(this.url + 'api/OrderEntry/GetOrderEntryDataByID?ccrid=' + ccrId);
  }

  getHistoryLogRecords(payload: any) {
    return this.apiService.post(this.url + `api/OrderEntry/GetAllHistoryLog`, payload);
  }

  saveOrder(request: any): Observable<any> {
  const body = encodeURIComponent(JSON.stringify(request));
  return this.apiService.postEncoded(this.url + 'api/OrderEntry/SaveOrder', body);
}

saveCustomerData(request: any): Observable<any> {
  const body = encodeURIComponent(JSON.stringify(request));
 
  return this.apiService.postEncoded(this.url + 'api/OrderEntry/SaveCustomerData', body);
}

  saveOldCustomerData(request: any): Observable<any> {
     const body = encodeURIComponent(JSON.stringify(request));
    return this.apiService.postEncoded(this.url + 'api/OrderEntry/SaveOldAddressData', body);
  }
  saveNewServiceData(request: any): Observable<any> {
     const body = encodeURIComponent(JSON.stringify(request));
    return this.apiService.postEncoded(this.url + 'api/OrderEntry/SaveCustomerNewSvcData', body);
  }

  saveOrderData(request: any): Observable<any> {
    const body = encodeURIComponent(JSON.stringify(request));
    return this.apiService.postEncoded(this.url + 'api/OrderEntry/SaveOrderData', body);
  }
}
